import easelAPI, { EaselResponse, postOptions } from 'apis/helpers/easelAPI'

const getGoogleRecommendedArtworks = async ({
  artworkId,
  category,
  event,
  experiment,
  pageSize,
  placement,
  visitorId,
  filter,
  pageCategories,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      artworkId,
      // Strip trailing `s` - Paintings => Painting
      // Change Mixed Media => Mixedmedia
      category: category.replace(/s$/, '').replace(/\sM/, 'm'),
      event,
      experiment,
      pageSize,
      placement,
      visitorId,
      filter,
      pageCategories,
    }),
  }
  const json = await easelAPI.fetchJSON({
    name: 'getGoogleRecommendedArtworks',
    options,
    url: '/recommended-artworks',
  })
  return json
}

export default getGoogleRecommendedArtworks
